import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TComplain } from "apis/meeting-room-complain";

type ComplainHeaderProps = {
  section?: "미처리 민원" | "처리 완료 민원";
  totalCount?: number;
  checkedComplainList?: TComplain[];
  onHandleAllCheck?: (value: boolean) => void;
};
const ComplainHeader = ({ section, totalCount, checkedComplainList = [], onHandleAllCheck }: ComplainHeaderProps) => {
  return (
    <Header>
      <HeaderItem minWidth={24} maxWidth={24}>
        <UI.CheckBox
          type={totalCount === checkedComplainList.length ? "selected" : "indeterminate"}
          size="medium"
          onChange={onHandleAllCheck}
          selected={checkedComplainList.length > 0}
        />
      </HeaderItem>
      {section !== "미처리 민원" && (
        <HeaderItem minWidth={160} maxWidth={200}>
          <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
            처리 완료 일시
          </UI.Typography>
        </HeaderItem>
      )}
      <HeaderItem minWidth={160} maxWidth={200}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          민원 등록 일시
        </UI.Typography>
      </HeaderItem>
      <HeaderItem minWidth={160} maxWidth={200}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          회의실
        </UI.Typography>
      </HeaderItem>
      <HeaderItem minWidth={160} maxWidth={200}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          민원 유형
        </UI.Typography>
      </HeaderItem>
      <HeaderItem minWidth={240}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          민원 상세 내용
        </UI.Typography>
      </HeaderItem>
    </Header>
  );
};

export default ComplainHeader;

const Header = styled.div`
  box-sizing: border-box;
  padding: 12px 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 32px;
  min-width: 1100px;

  border-radius: 12px;
  background-color: var(--component-color-fill-alternative);
`;

const HeaderItem = styled.div<{ minWidth?: number; maxWidth?: number }>`
  min-width: ${(props) => props.minWidth}px;
  max-width: ${(props) => props.maxWidth}px;
  width: 100%;
`;
